<template>
  <!--
      作者 kmdshop
      时间：2020-9-25
      描述：设置-仓库设置
  -->
  <div>
    <!--form表单-->
    <el-form size="small" ref="formData" :model="formData" label-width="150px">
      <!--仓库设置-->
      <div class="common-form">仓库设置</div>
      <el-form-item label="是否开启仓库" prop="is_open_storage"><el-switch v-model="formData.is_open_storage"></el-switch></el-form-item>
      <el-form-item label="仓库页面标题" :rules="[{ required: true, message: '请填写页面标题' }]" prop="title">
        <el-input class="max-w460" v-model="formData.title" placeholder="" type="text"></el-input>
        <div class="gray">小程序页面标题</div>
      </el-form-item>
      <el-form-item label="仓库图片" :rules="[{required: true,message: '请上传仓库图片'}]">
        <el-button @click="chooseImg">选择图片</el-button>
        <img class="mt10" v-img-url="formData.image" width="200">
      </el-form-item>
      <el-form-item label="仓库说明:">
        <el-input type="textarea" v-model="formData.detail" :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="赠送说明:">
        <el-input type="textarea" v-model="formData.giving_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="退货说明:">
        <el-input type="textarea" v-model="formData.sales_return_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="拍卖说明:">
        <el-input type="textarea" v-model="formData.auction_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="回购说明:">
        <el-input type="textarea" v-model="formData.repo_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="封坛说明:">
        <el-input type="textarea" v-model="formData.FengTan_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <el-form-item label="提货说明:">
        <el-input type="textarea" v-model="formData.pick_detail"  :autosize="{ minRows: 2, maxRows: 10}"  style="width:500px;"></el-input>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">提交</el-button>
      </div>
    </el-form>

    <!--上传图片-->
    <Upload v-if="isupload" :isupload="isupload" :config="{ total: 3 }" @returnImgs="returnImgsFunc"></Upload>
  </div>
</template>

<script>

  import SettingApi from '@/api/storage.js';
  import Upload from '@/components/file/Upload';
  export default{
    components:{
      Upload,
    },
    
    data(){
      return {
        /*是否正在加载*/
        loading:true,
        /*表单数据对象*/
        formData:{
          image:'',
          is_open_storage:false,
          title:'',
          detail:'',
          giving_detail:'',
          sales_return_detail:'',
          auction_detail:'',
          repo_detail:'',
          FengTan_detail:'',
          pick_detail:''
        },
        /*是否打开图片选择*/
        isupload:false,
      }
    },
    created() {
      this.getParams();
    },
    methods:{

      /*获取配置数据*/
      getParams() {
        let self = this;
        SettingApi.getDepot({}, true).then(res => {
            if (res.code == 1) {
              self.formData=res.data.vars.values;
              self.loading=false;
            } else {
              console.log();
            }
          })
          .catch(error => {

          });
      },

      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.formData;
        self.$refs.formData.validate((valid) => {
          if (valid) {
            self.loading = true;
            SettingApi.setDepot(params, true)
              .then(data => {
                self.loading = false;
                self.$message({
                  message: '恭喜你， 仓库设置成功',
                  type: 'success'
                });
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });

      },
      /*选择图片*/
      chooseImg(){
        this.isupload=true;
      },

      /*关闭选择图片*/
      returnImgsFunc(e){
        this.isupload=false;
        this.formData.image=e[0].file_path;
      },
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/plus/storage/depot/setting.vue